import areaApi from '@/api/config/areaApi'
import { queryKeys } from '@/constant/common'
import { CreateArea } from '@/types/areaZone'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function createArea(payload: CreateArea): Promise<void> {
  await areaApi.create(payload)
}
const useAddArea = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreateArea) => createArea(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.areaZone])
      toast.success(t('addAreaSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
  })
}

export default useAddArea
